module.exports = __webpack_public_path__ + "img/logo.9d5b2e05.png";